import axios from '../config/axios';
import {
	ID_DATA_TABLE, 
	ID_PC, 
	LISTAR_POR_PERIODO, 
	NAVIGATION_TREE, 
	NAVIGATION_TREE_PC, 
	TREE_SELECTEDS, 
	TREE_SELECTEDS_PC,
	RESET_PROJECT,
	URL_TREE_PC,
	URL_TREE_PROJECT,
	HEADER_NAV,
	CLEAN_TREE_CHILDS,
	URL_TREE_MEANS,
	CLEAN_TREE_MEANS,
	TREE_SELECTEDS_MEANS,
	RESET_TREE_PROJECTS,
	RESET_TREE_CLASSIFICATION,
	RESET_RIGHT_INFORMATION,
	RESET_RIGHT_INFORMATION_GRAPHIC,
	ARBOL,
	MONTH_RESOURCES,
	RESET_MONTH_RESOURCES,
	PROYECT_DATES,
} from '../constants';
import {ClassificationFn, DateLocal} from './helper';
let company = JSON.parse(localStorage.getItem("company-s10"));
let user = JSON.parse(localStorage.getItem("user-s10"));

const signalRequest = async ( requestId, objectName, hasOutputParam = false ) => {
	const body = {
		HasOutputParam: hasOutputParam,
		ObjectName: objectName,
		RequestId: requestId,
		SignalRConnectionID: await localStorage.getItem("connectionId"),
		SecurityUserId: user.IdUser ? user.IdUser : user.UserId, // SecurityUserId obtenido al logear
	};
	const headers = {
		Token: company.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
	};
	
	await axios.post( 
		"",
		body,
		{
			headers: headers,
		}
	);
}

// @CodProyecto		VARCHAR(60),
// @Tipo				VARCHAR(2) = '01',
// @CodClasificacion	VARCHAR(60) = '',
// @CodPeriodo			Varchar(6) = '',
// @Escala				Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año
export const selectProyect = (idCod, codType = '01', date = '', scale = '0') =>{
	return async (dispatch) =>{
		await signalRequest(
			"DATA_GENERAL",
			`dbo.S10_06_TableroProyecto10_Listar '${codType}', '${idCod}', '${date}', ${scale}`,
			// `dbo.S10_00_ResultadoOperativo_ListarPorPeriod o '${idCod}', '${codType}', '${codClasification}', ${finalDate}, 1`,
		);
		dispatch({
			type: ID_DATA_TABLE,
			payload: idCod
		})
	}
}
export const getProyectDates = (idCod, scale = '') =>{
	return async (dispatch) =>{
		await signalRequest(
			PROYECT_DATES,
			`dbo.S10_06_BI_ProyectoCalendario_Listar '${idCod}', ${scale}`,
		);
	}
}

export const selectProyectV2 = (idCod, codType = '01', date = '', scale='') =>{
	return async (dispatch) =>{
		await signalRequest(
			"MENSUAL_DETALLE",
			`dbo.S10_06_TableroProyecto10_Listar '${codType}', '${idCod}', '${date}', ${scale}`,
		);
		dispatch({
			type: ID_DATA_TABLE,
			payload: idCod
		})
	}
}

export const selectBusinessPCGCard = (idCod, codClassification, codType = '09', scale = '0', date='' ) =>{
	return async (dispatch) =>{

		await signalRequest(
			"MENSUAL_DETALLE",
			`dbo.S10_06_Tablero_PartidaControlListar '${idCod}', '${codType}', '${codClassification}', '${date}', ${scale}`,
		);
		dispatch({
			type: ID_DATA_TABLE,
			payload: idCod
		});
	}
}

export const resetRightInformation = () => {
	return async (dispatch) =>{
		dispatch({
			type: RESET_RIGHT_INFORMATION,
		})
	}

}

export const resetRightInformationGraphic = () => {
	return async (dispatch) =>{
		dispatch({
			type: RESET_RIGHT_INFORMATION_GRAPHIC,
		})
	}

}

export const selectPc = (idCod, idPc, classification, date = '', scale = '0') =>{
	return async (dispatch) =>{
		const type = ClassificationFn(classification);
		// card
		await signalRequest(
			"MENSUAL_DETALLE",
			`dbo.S10_06_Tablero_PartidaControlListar '${idCod}', '${type}', '${idPc}', '${date}', ${scale}`,
		);
		dispatch({
			type: ID_PC,
			payload: idPc
		})
	}
}

export const selectMean = (idCod, idPc, classification, idMean, date = '', scale='0') =>{
	return async () =>{
		const type = ClassificationFn(classification);
	
		await signalRequest(
			"MEANS_DATA",
			`dbo.S10_06_Tablero_ListarTipoRecurso '${idCod}', '${type}', '${date}', '${idPc}', '${idMean}', 1, ${scale}`,
		);
		
	}
}

export const selectMeanV2 = (idCod, idPc, classification, idMean, date = '', scale = '0') =>{
	return async () =>{
		const type = ClassificationFn(classification);
	
		await signalRequest(
			"MENSUAL_DETALLE",
			`dbo.S10_06_Tablero_ListarTipoRecurso '${idCod}', '${type}', '${date}', '${idPc}', '${idMean}', ${scale}`,
		);
		
	}
}

export const GraficoPCG = (codProyect, type, codClassification, accumulated = 1) =>{
	return async () =>{
		type = ClassificationFn(type);
		let yearMonth = localStorage.getItem("date-project");
		const yearMonthLocal = (yearMonth ? yearMonth : DateLocal()).replace('/', '');

		await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_06_PCG_Proyecto_ListarPorPeriodo '${codProyect}', '${type}', '${codClassification}', '${yearMonthLocal}', '${accumulated}'`,
		);
		
	}	
}
export const ListarPorPeriodoGrafico = (idCod, idData = '', codType, scale='', date = '') =>{
	return async () =>{
		
		const type = ClassificationFn(codType);
		await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_00_ResultadoOperativoGrafico_ListarPorPeriodo '${idCod}', '${type}', '${idData}', '${date}', ${scale}`,
			// `dbo.S10_00_ResultadoOperativoGrafico_ListarPorPeriodo '${idCod}', '${type}', '${idData && idData}', ${finalDate}`,
		);
		
	}
}

export const ListarPorPeriodoDetalles = (idCod, query, classification, scale='', date = '') =>{
	return async () =>{
	
		const type = ClassificationFn(classification);
		await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_00_ResultadoOperativo_ListarPorPeriodoDetalle '${idCod}', '${type}', '', '${query}', '${date}', ${scale}`,
		);
	}
}

export const ListarPorPeriodoDetallesGrafico = (idCod, query, idData = '', codType = '', scale = '', date = '') => {
	/*
	@CodProyecto		VARCHAR(8),
	@Tipo				VARCHAR(2) = '01',
	@CodClasificacion	VARCHAR(60) = '',
	@TipoDetalle		Varchar(2) = 'HH',
	@CodPeriodo			Varchar(6) = '',
	@Escala				Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año
	*/
	return async () =>{
		const type = ClassificationFn(codType);
		
		await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_00_ResultadoOperativoGrafico_ListarPorPeriodoDetalle '${idCod}', '${type}',  '${idData || ''}', '${query}', '${date}', ${scale}`,
		);
	}
}

// export const ListarPorPeriodoPc = (idCod, idPc, classification) =>{
// 	return async () =>{
// 		let yearMonth = localStorage.getItem("date-project");
// 		const yearMonthLocal = DateLocal()

// 		const type = ClassificationFn(classification);
// 		await signalRequest(
// 			"LISTAR_POR_PERIODO",
// 			`dbo.S10_00_ResultadoOperativo_ListarPorPeriodo '${idCod}', '${type}', '${idPc}', ${yearMonth ? `'${yearMonth.replace('/', '')}'` : `'${yearMonthLocal.replace('/', '')}'`}`,
// 		);
// 	}
// }

export const ListarPorPeriodo = (idCod, codClassification = '', classification = '01', date = '', scale = '') => {
	return async () => {
		const type = ClassificationFn(classification);
		await signalRequest(
			"LISTAR_POR_PERIODO",
			// `dbo.S10_00_ResultadoOperativo_ListarPorPeriod o '${idCod}', '${type}', '${codClassification}', ${finalDate}`,
			`dbo.S10_00_ResultadoOperativo_ListarPorPeriodo '${idCod}', '${type}', '${codClassification}', '${date}', ${scale}`,
		);
	}	
}

export const ListarPorPeriodoMains = (idCod, idPc, classification, idMains, acumulado, scale = '', date = '') =>{
	return async () =>{
		const type = ClassificationFn(classification);

		await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_06_TableroRecursoGrafico_Listar10 '${idCod}', '${type}', '${idPc}', '${idMains}', '${acumulado}', '${date}', ${scale}`,
		);
	}
}

export const TableMeans = (idCod, idPc, classification, idMains, scale = '', date = '') =>{
	return async () =>{
		const type = ClassificationFn(classification);
		await signalRequest(
			"MEANS_TABLE",
			`dbo.S10_06_TableroRecurso_Listar10 '${idCod}', '${type}', '${date}', '${idPc}', '${idMains}', ${scale}`,
		);

	}
}

export const ListarPorPeriodoPcDetalles = (idCod, idPc, query, classification, date = '', scale='') =>{
	return async () =>{
		const type = ClassificationFn(classification);
		  await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_00_ResultadoOperativo_ListarPorPeriodoDetalle '${idCod}', '${type}', '${idPc}', '${query}', '${date}', ${scale}`,
		);
	
	}
}

export const PCGProjectsGraphicWithHead = (codProject, codClassification, type, typeHead, accumulated) => {
	return async () =>{
		// const type = ClassificationFn(pType);
		let yearMonthStorage = await localStorage.getItem("date-project");
		const yearMonthLocal = (yearMonthStorage ? yearMonthStorage :  DateLocal()).replace('/', '');
		const params = `'${codProject}', '${type}', '${codClassification}', '${typeHead}', '${yearMonthLocal}', '${accumulated}'`
		  await signalRequest(
			"LISTAR_POR_PERIODO",
			`dbo.S10_06_PCG_Proyecto_ListarPorPeriodoDetalle ${params}`,
		);
	
	}
}

export const ProjectDetails = (idCod, type = '01', codType = '', scale='', date = '') =>{
	return async () => {
		await signalRequest(
			"PROJECT_DETAILS",
			`dbo.S10_06_Tablero_ListarProyectoDetalle '${idCod}', '${type}', '${codType}', '${date}', ${scale}`,
		);

	}
}

export const ProjectDetailsPc = (idCod, idPc, codType, scale = '', date = '') =>{
	return async () =>{
		const type = ClassificationFn(codType);
		// table data
		let spName = `S10_06_Tablero_ListarProyectoDetalle '${idCod}', '${type}', '${idPc}', '${date}', ${scale}`;
		if( idCod !== 'YYYYY002' && ['06', '07', '08', '09'].includes(type) ) {
			spName = `S10_06_PCG_Proyecto_ListarSumaRecurso '${idCod}', '${type}', '${idPc}', '${date}'`;
		}
		await signalRequest(
			"PROJECT_DETAILS",
			`dbo.${spName}`,
		);
	}
}

export const ClassificationResource = (idCod, classification, idClassification) =>{
	
	return async () =>{
		const type = ClassificationFn(classification);

		let yearMonth = localStorage.getItem("date-project");
		const yearMonthLocal = DateLocal();
		// arbol recursos
		await signalRequest(
			"CLASSIFICATION_DATA",
			`dbo.S10_06_TipoClcasificacion_ListarRecurso '${idCod}', '${type}', '${idClassification}', ${yearMonth ? `'${yearMonth.replace('/', '')}'` : `'${yearMonthLocal.replace('/', '')}'`}`,
		);
	}
}

export const ClassificationResourceV2 = (idCod, codType, idClassification, codInsumo='', level = 1, search = '') =>{
	
	return async () =>{
		const type = ClassificationFn(codType);

		let yearMonth = localStorage.getItem("date-project");
		const yearMonthLocal = DateLocal();
		// dbo.S10_06_TipoClcasificacion_ListarRecursoPorNivel @CodProyecto=N'01',@Tipo=N'06',@CodTipo=N'01',@CodPeriodo=N'202112', @CodInsumo=N'',@Nivel=1
		// arbol recursos
		const codPeriod = (yearMonth ? yearMonth : yearMonthLocal).replace('/', '');
		await signalRequest(
			"TREE_DATA_TAB_3",
			`dbo.S10_06_TipoClcasificacion_ListarRecursoPorNivel '${idCod}', '${type}', '${idClassification}', '${codPeriod}', '${codInsumo}', '${level}', '${search}'`,
		);
	}
}

export const listHistory = (codProyecto, idPc, query, classification, scale = '', date = '') => {
	/*
	@CodProyecto	VARCHAR(8),
	@Tipo			Varchar(2) = '01',
	@CodPC			VARCHAR(60) = '',
	@TipoDetalle	VARCHAR(2) = 'HH',

	@CodPeriodo		Varchar(6) = '',
	@Escala			Tinyint	= 0, -- 0 = Mensual, 1 = Semana, 2 = Año

	@TamanoPagina	Integer = 20,
	@NumeroPagina	Integer = 1,
	@EtiquetaPagina	Varchar(20)  = Null OUTPUT 
	*/
	// "dbo.S10_06_Tablero_ListarProyectoMensualDetalle '03001002', '01', '', '', '2019', 2, 20, 1"
	// "dbo.S10_06_Tablero_ListarProyectoMensualDetalle '03001002', '01', '', 'HH', '2019', 2, 20, 1"
	return async () =>{
		const type = ClassificationFn(classification);
		const finalIdPc = idPc || ''
		await signalRequest(
			"LIST_HISTORY",
			`dbo.S10_06_Tablero_ListarProyectoMensualDetalle '${codProyecto}', '${type}', '${finalIdPc}', '${query ? query : ''}', '${date}', ${scale}, 20, 1`
		);

	}
}

export const monthResources = async (codProyecto, typeName, idPc, query, page, accumulated, scale = '', date = '', head = '') => {
	/*
	@CodProyecto	VARCHAR(8),
	@Tipo			Varchar(2) = '01',
	@CodPeriodo		Varchar(6),
	@CodPC			VARCHAR(60) = '',
	@TipoDetalle	VARCHAR(2) = '',
	@TamanoPagina	Integer = 20,
	@NumeroPagina	Integer = 1,
	@EtiquetaPagina	Varchar(20)  = Null Output,
	@Acumulado		Bit = 1,
	@Descripcion	Varchar(1024) = '',
	@Escala			Tinyint	= 0 -- 0 = Mensual, 1 = Semana, 2 = Año
	*/
	const type = ClassificationFn(typeName);
	const request = `dbo.S10_06_Tablero_ListarProyectoMensualRecurso '${codProyecto}', '${type}', '${date}', '${idPc}', '${head}', 20, ${page}, '',${accumulated}, '${query || ''}', ${scale}`;
	console.log(MONTH_RESOURCES, request)
	await signalRequest(
		MONTH_RESOURCES,
		request,
		true,
	);
}

export const resetMonthResources = () => {
	console.log('resetMonthResources')
	return ({
		type: RESET_MONTH_RESOURCES,
	})
}


export const treeProject = () =>{
	return async () =>{
		await signalRequest(
			ARBOL,
			`dbo.s10_06_Proyecto_ListarArbol '${user.UserName}'`,
		);
}}

export const treePCGProjects = ( type='06', codPCGeneral) => {
	return async () =>{
		await signalRequest(
			ARBOL,
			`dbo.S10_06_TipoClcasificacion_ListarProyecto 'YYYYY002', '${type}', '${codPCGeneral}'`,
		);
	}
}

export const treeBusinessPCG = ( type='09', codUndBusiness) => {
	return async () =>{
		await signalRequest(
			ARBOL,
			`dbo.S10_06_TipoClcasificacion_ListarProyecto 'YYYYY002', '${type}', '${codUndBusiness}'`,
		);
	}
}

export const treePcg = (project = '', tipo = '06') =>{
	return async () =>{
		await signalRequest(
			"PARTY_CONTROL",
			`dbo.S10_06_TipoClcasificacion_Listar '${project}', '${tipo}'`,
		);
}}	

export const treeUn = (codMoney = '01', tipo = '06') =>{
	return async () =>{
		await signalRequest(
			"PARTY_CONTROL",
			`dbo.s10_06_TipoCIcasificacion_Listar '',  '${tipo}'`,
		);
}}	

export const treePc = (codPCUrl, type='01') =>{
	return async () =>{
		await signalRequest(
			"PARTY_CONTROL",
			`dbo.S10_06_TipoClcasificacion_Listar '${codPCUrl}', '${type}'`,
		);
	}
}

export const treeDe = (codPCUrl) =>{
	return async () =>{
		signalRequest(
			"TREE_DE",
			`dbo.S10_06_TipoClcasificacion_Listar '${codPCUrl}', '05'`,
		);
	}
}

export const treeFt = (codPCUrl) =>{
	return async () =>{
		signalRequest(
			"TREE_FT",
			`dbo.S10_06_TipoClcasificacion_Listar '${codPCUrl}', '04'`,
		);
	}
}

export const cleanDataChart = () =>{
	return (dispatch) =>
		dispatch({
			type: LISTAR_POR_PERIODO,
			payload: []
		})
}

export const navigationTree = (grupo) => ({
  type: NAVIGATION_TREE,
  payload: {grupo}
})

export const navigationTreePC = (grupo) => ({
  type: NAVIGATION_TREE_PC,
  payload: {grupo}
})


export const selectTree = (nodeId, forcedOpen = false) => {	
	return ({
		type: TREE_SELECTEDS,
		payload: {nodeId, forcedOpen}
	})
}

export const selectTreePc = (nodeId, forcedOpen) => {	
	return ({
		type: TREE_SELECTEDS_PC,
		payload: {nodeId, forcedOpen}
	})
}

export const selectTreeMeans = (nodeId, forcedOpen = false) => {	
	return ({
		type: TREE_SELECTEDS_MEANS,
		payload: {nodeId, forcedOpen}
	})
}

export const resetProject = () => {	
	return ({
		type: RESET_PROJECT,
	})
}

export const resetOnlyProject = () => {	
	return ({
		type: RESET_TREE_PROJECTS,
	})
}

export const resetOnlyClassification = () => {	
	return ({
		type: RESET_TREE_CLASSIFICATION,
	})
}

export const cleanTreeChilds = () => ({
	type: CLEAN_TREE_CHILDS
})

export const urlPc = (url) => ({
  type: URL_TREE_PC,
  payload: url
})

export const urlProject = (url) => ({
  type: URL_TREE_PROJECT,
  payload: url
});

export const urlMeans = (url) => ({
	type: URL_TREE_MEANS,
	payload: url
});

export const pcHeader = (s) => ({
  type: HEADER_NAV,
  payload: s
})

export const cleanMeans = () => ({
  type: CLEAN_TREE_MEANS
})
